import {
  pageSdkErrorKind,
  reportPageSdkError
} from '@Pages/pageRuntime/compiler/reportPageSdkError';
import { createContext, useContext } from 'react';

export type PageSdkErrorDetails = {
  source: 'page' | 'section';
  componentStack?: string | null;
};

export type PageSdkErrorReporter = (error: Error, details: PageSdkErrorDetails) => void;

const defaultReporter: PageSdkErrorReporter = (error, details) => {
  reportPageSdkError(error, {
    ...details,
    kind: pageSdkErrorKind(error),
    telemetryMode: 'remote',
    renderSurface: 'published'
  });
};

export const PageSdkErrorReportingContext = createContext<PageSdkErrorReporter>(defaultReporter);

export function usePageSdkErrorReporter(): PageSdkErrorReporter {
  return useContext(PageSdkErrorReportingContext);
}
